import { useMemo } from 'react';
import { useTasksQuery } from 'shared/hooks/queries/use-tasks-query';
import { useUser } from 'shared/hooks/use-user';
import { ID } from 'shared/types/id';

export const useGoalTasks = (id: ID = '') => {
  const user = useUser();
  const { data } = useTasksQuery(user?.uid, { goals: [id] }, !!id);

  return useMemo(() => data ?? [], [data]);
};
